class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    document.querySelectorAll( '.radio-dropdown_item.display' ).forEach( el => { 
      el.addEventListener( 'click', this.variantDropdownToggle )
    })
    document.querySelectorAll( '.radio-dropdown_item label' ).forEach( el => { 
      el.addEventListener( 'click', this.selectDropdownVariant )
    })
  }

  selectDropdownVariant( event ) {
    const dropdown  = this.parentElement.parentElement
    const value     = event.target.innerText
    const firstItem = dropdown.querySelector( '.radio-dropdown_item.display' )

    firstItem.innerText = value
    dropdown.classList.toggle( 'open' )
    dropdown.querySelectorAll( '.radio-dropdown_item label' ).forEach( el => { 
      el.classList.remove( 'selected' )
    })
    event.target.classList.add( 'selected' )
  }

  variantDropdownToggle(){
    this.parentElement.classList.toggle( 'open' )
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
		this.setAvailableOptions();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
			this.updateVariantSwatchColorDisplay();
      this.renderProductInfo();
    }
  }

	setAvailableOptions() {
		// TODO: Implement this for select based options, not currently in use
	}

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
		const {featured_image } = this.currentVariant
		const hasFeaturedImage = featured_image && featured_image.hasOwnProperty('id')
		const media = hasFeaturedImage ? featured_image.id : this.currentVariant.id
		
    const newMedia = document.querySelector(
      `#product-image-primary .c-product-image[data-media-id="${media}"]`
    );
		
    if (!newMedia) return;

		let updatedModalSrc = newMedia.querySelector('img').src,
			 	modalImgSrc 		= document.querySelector('.c-carousel-modal-img');

		modalImgSrc.src = updatedModalSrc;
		modalImgSrc.setAttribute('srcset', updatedModalSrc);

    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

	updateVariantSwatchColorDisplay() {
		const swatchTextDisplay = document.querySelector('.c-swatch-color-text');

		if ( !swatchTextDisplay ) return;

		swatchTextDisplay.innerText = this.currentVariant.title;
	}

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
				const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
				
        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();

		this.fieldsets = Array.from(this.querySelectorAll('fieldset'));

		this.allOptions = this.fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input[type="radio"]'))
			            .map(input => input.value)
		})

		this.onVariantChange()
  }

  updateOptions() {
    this.options = this.fieldsets.map((fieldset) => {
			let radio = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((radio) => radio.checked);

			if(radio) {
				return radio.value;
			}

			return null;
    });
  }

	setAvailableOptions() {
		const totalOptions = this.fieldsets ? this.fieldsets.length : 0

		// Bail here if there isn't more than 1 fieldset
		if( totalOptions < 2 ) return;

		const variantOptionCombos = this.variantData.map(variant => variant.options)

		// Based on the currently selected color, what sizes aren't available in that color?
		this.availableOptions = this.allOptions.map((values, index) => {
			// Get the value of the first selected option
			const [option1Value] = this.options

			// Get all combos that include the selected first option value
			const combos = variantOptionCombos.filter(combo => {
				return combo[0] === option1Value
			})

			// Keep all values for the first option
			if( index === 0 ) {
				return values
			}
			else {
				return values.filter(value => combos.some(combo => combo[index] === value))
			}
		})

		// Update the dom to prevent invalid selections
		this.updateOptionsDOM()
	}

	updateOptionsDOM() {
		console.log('updating DOM...')
		this.fieldsets.forEach((fieldset, i) => {
      const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
			const option = this.availableOptions[i]

			// Check if the input's value is the the available option values array
			// and disable if not found
			if( inputs && option ) {
				inputs.forEach(input => {
					console.log(input, !option.includes(input.value))
					input.disabled = !option.includes(input.value)
				})
			}
    });		
	}
}

customElements.define('variant-radios', VariantRadios);

//////

class WholesaleVariant extends HTMLElement {
  constructor() {
    super();

		this.quantityInput  = this.querySelector( '[quantity-input]' );
		this.increaseButton = this.querySelector( '[quantity-increase]' );
		this.decreaseButton = this.querySelector( '[quantity-decrease]' );

    this.increaseButton.addEventListener( 'click', function(event) {
			this.increaseQuantity();
		}.bind( this ) );

    this.decreaseButton.addEventListener( 'click', function(event) {
			this.decreaseQuantity();
		}.bind( this ) );

		this.quantityInput.addEventListener( 'change', function(event) {
			event.stopPropagation();
			this.setQuantity( this.getQuantity() );
		}.bind( this ));

		this.available = this.dataset.available;
  }

	getVariantId() {
		return parseInt( this.dataset.variantId );
	}

	getMinimumQuantity() {
		let minimum = parseInt( this.dataset.minimumQuantity );

		if( isNaN( minimum ) ) {
			return 0;
		}

		return minimum;
	}

	getQuantity() {
		let quantity = parseInt( this.quantityInput.value );

		if( isNaN( quantity ) ) {
			return 0;
		}

		return quantity;
	}

	setQuantity( quantity ) {
		quantity = parseInt( quantity );

		if( quantity < 0 || isNaN( quantity ) ) {
			quantity = 0;
		}

		if( quantity > 0 && quantity < this.getMinimumQuantity() ) {
			quantity = this.getMinimumQuantity();
		}

		this.quantityInput.value = quantity;
		this.dispatchEvent( new Event( 'change', { bubbles: true } ) );
	}

	increaseQuantity() {
		let quantity = this.getQuantity() + 1;

		if( quantity > 0 && quantity < this.getMinimumQuantity() ) {
			quantity = this.getMinimumQuantity();
		}

		this.setQuantity( quantity );
	}

	decreaseQuantity() {
		let quantity = this.getQuantity() - 1;

		if( quantity < this.getMinimumQuantity() ) {
			quantity = 0;
		}

		this.setQuantity( quantity );
	}

	get available() {
		return this.dataset.available === 'true';
	}

	get disabled() {
		return this.quantityInput.disabled;
	}

	set available( available ) {
		this.dataset.available = available ? 'true' : 'false';

		this.disabled = ! this.available;
	}

	set disabled( disabled ) {
		this.quantityInput.disabled  = disabled;
		this.increaseButton.disabled = disabled;
		this.decreaseButton.disabled = disabled;
	}

}

customElements.define( 'wholesale-variant', WholesaleVariant );

//////

class WholesaleForm extends HTMLElement {
	constructor() {
		super();

		this.variantData         = JSON.parse( this.querySelector('[type="application/json"]').textContent );
		this.submitButton        = this.querySelector( '[type="submit"]' );
		this.noVariantsMessage   = this.querySelector( '[no-variants-message' );
		this.variantsDisplay     = this.querySelector( '[variants-display]' );

		this.addEventListener( 'change', this.onVariantChange );
		this.submitButton.addEventListener( 'click', this.submit.bind( this ) );
	}

	onVariantChange( event ) {
		this.variantData.forEach( variant => {
			if( variant.id === event.target.getVariantId() ) {
				variant.quantity = event.target.getQuantity();
			}
		});

		this.update();
	}

	update() {
		let disableSubmit  = true;
		let overviewMarkup = [];
		let subTotal       = 0;

		this.variantData.forEach( variant => {
			if( variant.quantity ) {
				let formattedPrice = new Intl.NumberFormat( 'en-US', { style: 'currency', currency: 'USD' } ).format( variant.price * variant.quantity / 100 );
				
				overviewMarkup.push(`
					<div class="flex text-gray-700">
						<span class="w-3/4">${variant.title}</span>
						<span class="w-10 text-center whitespace-nowrap">
							<span class="inline-block text-gray-500 w-5">x</span>
							<span class="inline-block w-8">${variant.quantity}</span>
						</span>
						<span class="w-1/4 text-right">${formattedPrice}</span>
					</div>
				`);

				subTotal      += variant.price * variant.quantity;
				disableSubmit  = false;
			}
		});

		if( disableSubmit ) {
			this.noVariantsMessage.style.display = 'block';
			this.variantsDisplay.style.display   = 'none';
			this.disableSubmit();
		}
		else {
			this.noVariantsMessage.style.display = 'none';
			this.variantsDisplay.style.display   = 'block';
			this.enableSubmit();
		}

		let formattedSubTotal = new Intl.NumberFormat( 'en-US', { style: 'currency', currency: 'USD' } ).format( subTotal / 100 );

		this.submitButton.disabled      = disableSubmit;
		this.variantsDisplay.innerHTML  = overviewMarkup.join('');
		this.variantsDisplay.innerHTML += `
			<div class="flex">
				<span class="text-right text-primary text-xl w-full">${formattedSubTotal}</span>
			</div>
		`;
	}

	submit() {
		this.disableSubmit();	
		this.disableInputs();

		Shopify.queue = this.variantData.filter( variant => {
			return variant.quantity;
		});

		Shopify.moveAlong = function() {
			if( Shopify.queue.length ) {
				var variant = Shopify.queue.shift();
				var data    = 'id=' + variant.id + '&quantity=' + variant.quantity;

				jQuery.ajax({
					type: 'POST',
					url: '/cart/add.js',
					dataType: 'json',
					data: data,
					success: function( response ) {
						if ( Shopify.queue.length ) {
							Shopify.moveAlong();
						}
						else {
							window.location.replace( '/cart' );
						}
					},
					error: function( xhr, status, error ) {
						if (Shopify.queue.length){
							Shopify.moveAlong();
							console.log( 'error', xhr, status, error );
						} 
						else {
							console.log( 'done with error', xhr, status, error) ;
							window.location.replace( '/cart' );
						}
					}
				});
			}
		};

		Shopify.moveAlong();
	}

	disableSubmit() {
		this.submitButton.disabled = true;
	}

	disableInputs() {
		this.querySelectorAll( 'wholesale-variant' ).forEach( element => element.disabled = true );
	}

	enableSubmit() {
		this.submitButton.disabled = false;
	}

	enableInputs() {
		this.querySelectorAll( 'wholesale-variant' ).forEach( element => element.disabled = false );
	}
}

customElements.define( 'wholesale-form', WholesaleForm );

// class ProductLifestyleImages {
//   constructor() {
//     const buttons = document.querySelectorAll('#product-lifestyle-images button')

//     Array.from(buttons).forEach((element) => {
//       element.addEventListener('click', (e) => {
//         const image = document.getElementById(element.getAttribute('aria-controls'))
//         console.log(element.ariaControls, element.getAttribute('aria-controls'), image)
//         if( !image ) return;
//         const parent = image.parentElement;
//         parent.prepend(image);
//         window.setTimeout(() => { parent.scroll(0, 0) });
//       })
//     })
//   }
// }
// new ProductLifestyleImages();